import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../service/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService implements HttpInterceptor {

  private handlingUnauthorized = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !this.handlingUnauthorized) {
        this.handlingUnauthorized = true;
        this.authenticationService.logoutLocally();
        void this.router.navigate(['/'], { queryParams: { errorCode: '440' } }).finally(() => {
          this.handlingUnauthorized = false;
        });
      }

      const error = err.error?.message ?? err.statusText;
      return throwError(() => error);
    }));
  }

}
